import React from 'react';
import './SingleProjectBanner2.css';
import { Link } from 'react-router-dom';
import CommonButton from '../../../utility/components/CommonButton';
import projectimage from '../../../assets/img/projectbanner-2.jpg';


export const SingleProjectBanner2 = ({ title }) => {

    return (
        <div className="single-project__container">
            <img src={projectimage} alt="banner skip to quzi background" className="banner-quzi-background" />
            <div className="banner-quzi-content">
                <h1 className="project-name">Quiz</h1>
                <Link to={`/quiz`}>
                    <CommonButton size='large' presetStyle='light'>Take Quiz</CommonButton>
                </Link>
            </div>
        </div>
    );
};